import { configureAuth } from 'react-query-auth';
import { Navigate, Outlet, useParams } from 'react-router';
import { z } from 'zod';

import { LoadingSpinner } from '@/components/ui/spinner';
import { ROLE_ENUM } from '@/const/role';
import { api, removeToken, setToken } from '@/lib/api-client';
import { AuthResponse, User } from '@/types/auth/auth';

const getUser = async (): Promise<User> => {
  console.info('auth.tsx_1');

  return api.get('/auth/me');
};

const logout = async (): Promise<void> => {
  console.info('auth.tsx_2');

  removeToken();
};

export const loginInputSchema = z.object({
  username: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('有効なメールアドレスを入力してください'),
  password: z.string().min(1, 'パスワードは必須です'),
  client_id: z.string().min(1, 'クライアントIDは必須です'),
});

export type LoginInput = z.infer<typeof loginInputSchema>;
const loginWithEmailAndPassword = async (
  data: LoginInput,
): Promise<AuthResponse> => {
  console.info('auth.tsx_3');

  const formData = new FormData();
  formData.append('username', data.username);
  formData.append('password', data.password);
  formData.append('client_id', data.client_id);

  return api.post('/auth/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const registerInputSchema = z.object({
  username: z.string().min(1, 'Required'),
  password: z.string().min(5, 'Required'),
});

export type RegisterInput = z.infer<typeof registerInputSchema>;

const registerWithEmailAndPassword = async (
  data: RegisterInput,
): Promise<AuthResponse> => {
  console.info('auth.tsx_4');

  return api.post('/auth/register', data);
};

const authConfig = {
  userFn: getUser,
  loginFn: async (data: LoginInput) => {
    console.info('auth.tsx_5');

    const response = await loginWithEmailAndPassword(data);

    if (response.access_token) {
      console.info('auth.tsx_6');
      setToken(response.access_token);
    }
    console.info('auth.tsx_7');
    return response.user;
  },
  registerFn: async (data: RegisterInput) => {
    console.info('auth.tsx_8');

    const response = await registerWithEmailAndPassword(data);
    return response.user;
  },
  logoutFn: logout,
};

export const { useUser, useLogin, useLogout, useRegister, AuthLoader } =
  configureAuth(authConfig);

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  console.info('auth.tsx_9');

  const tenantSlug = useParams().tenantSlug;
  const user = useUser({
    refetchOnMount: true,
  });

  if (user.isLoading) {
    console.info('auth.tsx_10');
    return <LoadingSpinner />;
  }
  console.info('auth.tsx_11');

  if (!user.data) {
    console.info('auth.tsx_12');

    return <Navigate to={`/${tenantSlug}/auth/login`} replace />;
  }
  console.info('auth.tsx_13');

  // 別テナントへのアクセスを防ぐ
  if (user.data.url_slug !== tenantSlug) {
    console.info('auth.tsx_14');

    removeToken();
    return <Navigate to={`/${tenantSlug}/auth/login`} replace />;
  }
  console.info('auth.tsx_15');

  return children;
};

// エラーハンドリングの追加
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response && error.response.status === 401) {
//       removeToken();
//       // ユーザーをログインページにリダイレクト
//       window.location.href = '/auth/login';
//     }
//     return Promise.reject(error);
//   },
// );

export const ProtectedRouteForAdminAndSecretariat = () => {
  console.info('auth.tsx_16');
  const tenantSlug = useParams().tenantSlug;
  const user = useUser({
    refetchOnMount: true,
  });

  // if (user.isLoading) {
  //   return;
  // }

  if (
    !user.data ||
    ![ROLE_ENUM.ADMIN, ROLE_ENUM.SECRETARIAT].includes(user.data.role_id)
  ) {
    console.info('auth.tsx_17');
    return <Navigate to={`/${tenantSlug}/app/not-found`} replace />;
  }
  console.info('auth.tsx_18');

  return <Outlet />;
};

export const ProtectedRouteForAdmin = () => {
  console.info('auth.tsx_19');
  const tenantSlug = useParams().tenantSlug;
  const user = useUser({
    refetchOnMount: true,
  });

  // if (user.isLoading) {
  //   return;
  // }

  if (!user.data || user.data.role_id !== ROLE_ENUM.ADMIN) {
    console.info('auth.tsx_20');
    return <Navigate to={`/${tenantSlug}/app/not-found`} replace />;
  }
  console.info('auth.tsx_21');

  return <Outlet />;
};
